import { getEnv } from '@utils/env'

const isTruthyEnvFlag = (value: string): boolean =>
  ['true', '1', 'yes'].includes(value.trim().toLowerCase())

export function isPatientTrayMocksEnabled(): boolean {
  const explicit = getEnv('REACT_APP_MOCK_PATIENT_TRAY', '')
  if (explicit === 'false') return false
  if (isTruthyEnvFlag(explicit)) return true
  if (isTruthyEnvFlag(getEnv('REACT_APP_USE_SETTINGS_MOCKS', ''))) return true

  const appEnv = getEnv('REACT_APP_ENV', 'local').trim().toLowerCase()
  if (appEnv === 'local' || appEnv === 'dev' || appEnv === 'development') {
    return true
  }

  return process.env.NODE_ENV === 'development'
}

export function isMockPatientId(patientId?: string | null): boolean {
  return !!patientId?.startsWith('mock-patient-')
}

/** Demo patient IDs use tray mocks only when local/dev mocks are enabled. */
export function shouldUsePatientTrayMockData(
  patientId?: string | null,
): boolean {
  return isMockPatientId(patientId) && isPatientTrayMocksEnabled()
}
